<template>
  <div class="price">
    <div class="price_item">
      <div class="price_title">软件服务项目</div>
      <img src="../../assets/img/price_img.png" alt="" class="price_img mTop50">
    </div>
    <div class="price_item">
      <div class="price_title">背景调查版本</div>
      <el-table class="price_table" :data="data1" border stripe header-row-class-name="price_header">
        <el-table-column
          prop="version"
          align="center"
          width="285"
          label="背调版本">
        </el-table-column>
        <el-table-column
          prop="info"
          align="center"
          width="400"
          label="背景调查内容说明">
          <template slot-scope="scope">
            <div class="info" v-html="scope.row.info">
              
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="time"
          align="center"
          label="最快反馈时间">
        </el-table-column>
        <el-table-column
          prop="now_price"
          align="center"
          label="现价">
          <template slot-scope="scope">
            <div>
              <div class="now_price">{{scope.row.now_price}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="price"
          align="center"
          label="优惠价">
          <template slot-scope="scope">
            <div>
              <div class="sale_price">{{scope.row.price}}</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="price_item">
      <div class="price_title">背景调查项目</div>
      <el-table class="price_table" :data="data2" border stripe header-row-class-name="price_header">
         <el-table-column
          type="index"
          label="序号"
          align="center"
          width="64"
          :index="indexMethod">
         </el-table-column>
        <el-table-column
          prop="version"
          align="center"
          width="225"
          label="背景调查服务项目">
        </el-table-column>
        <el-table-column
          prop="info"
          align="center"
          width="400"
          label="背景调查服务项目说明">
        </el-table-column>
        <el-table-column
          prop="time"
          align="center"
          label="最快反馈时间">
        </el-table-column>
        <el-table-column
          prop="now_price"
          align="center"
          label="市场价格">
          <template slot-scope="scope">
            <div>
              <div class="now_price">{{scope.row.now_price}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="price"
          align="center"
          label="现价">
          <template slot-scope="scope">
            <div>
              <div class="sale_price">{{scope.row.price}}</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="price_warning">
      <div class="warning_title">* 注意</div>
      <div class="warning_content">1.所有个人产品均需要获得被查询人合法有效的授权.</div>
      <div class="warning_content">2.以上产品价格仅针对中国大陆地区有效.</div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      data1: [
        {
          version: '极速版',
          info: '1. 身份验证<br/>2. 手机信息实名验证<br/>3.手机在网时长查询<br/>4.手机在网状态查询<br/>5.身份证手机号码归属地<br/>6.资格证书查询',
          time: '1分钟',
          now_price: '45元',
          price: '18元/人次'
        },
        {
          version: '标准版',
          info: '1. 身份验证<br/>2. 手机信息实名验证<br/>3.手机在网时长查询<br/>4.手机在网状态查询<br/>5.身份证手机号码归属地<br/>6.法院失信信息<br/>7.法院被执行人信息<br/>8.公检法曝光台<br/>9.网贷黑名单<br/>10.资格证书查询<br/>11.最高学历查询<br/>12.最高学位查询',
          time: '1个工作日',
          now_price: '125元',
          price: '48元/人次'
        },
        {
          version: '专业版',
          info: '1. 身份验证<br/>2. 手机信息实名验证<br/>3.手机在网时长查询<br/>4.手机在网状态查询<br/>5.身份证手机号码归属地<br/>6.法院失信信息<br/>7.法院被执行人信息<br/>8.公检法曝光台<br/>9.网贷黑名单<br/>10.资格证书查询<br/>11.最高学历查询<br/>12.最高学位查询<br/>13.个人工商信息查询',
          time: '1个工作日',
          now_price: '195元',
          price: '68元/人次'
        },
      ],
      data2: [
        {
          version: '身份验证',
          info: '通过中国大陆公安部公民身份信息系统查询，验证身份证信息合法性',
          time: '1分钟',
          now_price: '10元',
          price: '5元'
        },
        {
          version: '手机信息实名验证',
          info: '核实候选人所使用的手机号是否为本人实名认证',
          time: '1分钟',
          now_price: '10元',
          price: '5元'
        },
        {
          version: '手机在网时长查询',
          info: '验证手机的在网时长区间，按自然月统计。在网时长=销号时间-开户时间，停机计入时长。',
          time: '1分钟',
          now_price: '10元',
          price: '5元'
        },
        {
          version: '手机在网状态查询',
          info: '验证移动、联通、电信手机的在网状态。',
          time: '1分钟',
          now_price: '10元',
          price: '5元'
        },
        {
          version: '身份证手机号码归属地',
          info: '验证候选人身份证、手机号归属地',
          time: '1分钟',
          now_price: '10元',
          price: '5元'
        },
        {
          version: '法院失信信息',
          info: '通过中国大陆公安部公民身份信息系统查询，核实候选人是否失信人员',
          time: '1分钟',
          now_price: '20元',
          price: '10元'
        },
        {
          version: '法院被执行人信息',
          info: '通过中国大陆公安部公民身份信息系统查询，核实候选人是否被执行人员',
          time: '1分钟',
          now_price: '20元',
          price: '10元'
        },
        {
          version: '公检法曝光台',
          info: '通过中国大陆公安部公民身份信息系统查询，核实候选人是否存在曝光信息',
          time: '1分钟',
          now_price: '20元',
          price: '10元'
        },
        {
          version: '网贷黑名单',
          info: '通过中国大陆公安部公民身份信息系统查询，核实候选人是否网贷黑名单',
          time: '1分钟',
          now_price: '20元',
          price: '10元'
        },
        {
          version: '资格证书查询',
          info: '通过中国大陆人社部OSTA数据库查询验证由人社部颁发的职业资格证书的有效性以及输出详情信息',
          time: '1分钟',
          now_price: '50元',
          price: '20元'
        },
        {
          version: '最高学历查询',
          info: '通过教育部在线系统/颁证学校核实，只支持查询2001年之后',
          time: '1个工作日',
          now_price: '50元',
          price: '20元'
        },
        {
          version: '最高学位查询',
          info: '通过教育部在线系统/颁证学校核实，只支持查询2008年之后',
          time: '1个工作日',
          now_price: '50元',
          price: '20元'
        },
        // {
        //   version: '个人不良核实',
        //   info: '通过中国大陆公安部公民身份信息系统查询，核实面试者犯罪信息（在逃、前科、吸毒等）',
        //   time: '1分钟',
        //   now_price: '50元',
        //   price: '20元'
        // },
        {
          version: '个人工商信息查询',
          info: '企业法人信息、企业股东信息、企业主要管理人员信息、失信被执行人信息、被执行人信息、行政处罚历史信息',
          time: '1分钟',
          now_price: '80元',
          price: '50元'
        },
      ]
    };
  },
  mounted: function() {
    this.$store.dispatch("first_nav_change", "3");
  },
  computed: {},
  methods: {
    indexMethod(index) {
      return index+1;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/price.vue